import React from 'react';

const Loader = () => {
    return (
        <div>
            <h2>loading deeply..</h2>
        </div>
    );
};

export default Loader;
